<template>
  <Multiselect
    class="customer-switch"
    trackBy="Name"
    valueProp="ID"
    label="Name"
    searchable
    :placeholder="currentCustomer.Name"
    :modelValue="currentCustomer.ID"
    :options="options"
    @select="setCustomer"
  />
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'CustomerSwitch',
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const list = store.getters['customers/list']

    const options = [...list].sort((a, b) => a.Name > b.Name)

    options.unshift({
      ID: '',
      Name: '- go to overview -'
    })

    function setCustomer (customerId = null) {
      store.commit('jobs/RESET')
      store.commit('subscriptions/RESET')
      store.commit('jobGroups/RESET')

      if (!customerId) {
        store.commit('customers/SET_CUSTOMER', {})
        router.push({ name: 'customers' })
      } else {
        store.commit('customers/SET_CUSTOMER', options.find(customer => customer.ID === customerId))
        store.dispatch('jobs/setTimer', true)
        store.dispatch('jobGroups/fetchGroups')

        if (!route.meta.allowCustomerSwitch) {
          // redirecting to homepage and simulating route change to reload default page
          router.push('/')
        }
      }
    }

    return {
      currentCustomer: computed(() => store.getters['customers/customer']),
      options,
      setCustomer
    }
  }
}
</script>

<style>
.customer-switch {
  .multiselect {
    &-single-label {
      color: #03539c;
      font-size: 17px;
      font-weight: 500;
      cursor: pointer;

      .citizen-m & {
        color: #fff;
      }
    }

    &-clear {
      .citizen-m & {
        background: #000;
      }
    }

    &-option {
      transition: color, background-color .2s;

      &.is-pointed {
        background: #e1e8f6;

        .citizen-m & {
          background: #f56c6c;
        }
      }

      &.is-selected,
      &.is-pointed.is-selected {
        background: #03539c;
        color: #fff;

        .citizen-m & {
          background: #ff0038;
        }

        &.is-pointed {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
